import { render } from "./engineering.svg?vue&type=template&id=c1473ca2?inline"
const script = {}
script.render = render

export default script